<template lang="pug">
  .notifications-settings
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('zoo_apps') }}
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content(v-else)
        v-card.pa-4(flat style="border:1px solid var(--v-basic300); border-radius:0")
          v-row(no-gutters)
            v-col
              .s1.primary500--text {{ $t('hide_company_zoo') }}
              .c1.basic600--text {{ $t('your_customer_will_not') }}
            v-col.shrink
              y-switch.mr-n2.mb-n3(v-model="hide_company")
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NotificationsSettings',
  props: ['company'],
  data () {
    return {
      isFetching: false,
      data: {},
      hide_company: false,
    }
  },
  computed: {
    ...mapState('user', ['member']),
  },
  mounted () {
    this.fetchSettings()
  },
  watch: {
    hide_company () {
      this.updateSettings()
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.isFetching = true
      this.$axios.get(`/zoo/settings/${this.company.slug}`)
        .then((response) => {
          this.data = response.data
          this.hide_company = response.data.hide_company
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateSettings () {
      this.$axios.patch(`/zoo/settings/${this.company.slug}`, { hide_company: this.hide_company })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    clickOpenDownloadApp () {
      window.open('https://yezza.io/')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "zoo_apps": "Zoo Apps",
    "hide_company_zoo": "Hide Company in Zoo App",
    "your_customer_will_not": "Your customer will not receive any notification & unable to track order from your company"
  },
  "id": {
    "zoo_apps": "Zoo Apps",
    "hide_company_zoo": "Sembunyikan perusahaan di Zoo App",
    "your_customer_will_not": "Pelanggan kamu tidak akan menerima notifikasi apa pun & tidak dapat melacak pesanan dari perusahaan kamu"
  },
  "ms": {
    "zoo_apps": "Zoo Apps",
    "hide_company_zoo": "Sembunyikan perusahaan di Zoo App",
    "your_customer_will_not": "Pelanggan kamu tidak akan menerima notifikasi apa pun & tidak dapat melacak pesanan dari perusahaan kamu"
  }
}
</i18n>